if (!customElements.get('custom-slider')) {
  customElements.define(
    'custom-slider',
    class CustomSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperEle = this.querySelector('.swiper');
        this.swiperSettings = JSON.parse(this.querySelector('#swiper-setting-data').innerHTML);
        console.log(this.swiperSettings);
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        if (window.innerWidth < 768) {
          if (!this.swiperEle) return;
          this.swiper = new Swiper(this.swiperEle, this.swiperSettings);
        }
      }
    }
  );
}
